import webBiLogger from '@wix/web-bi-logger';
import {
    uouActionClicked,
    uouActionCtaButtonClickedSrc146Evid95,
    uouActionCtaButtonViewedSrc146Evid96,
    uouActionImpressionSrc146Evid93,
    uouActionInnerItemGoalAchieved,
    uouActionInnerItemPreviewedSrc146Evid94,
    uouActionStartUnlockingSrc146Evid91,
    uouActionUnlocked,
    uouActionViewed,
    uouActivity,
    uouAnyActionClicked,
    uouAutoRedirectCanceledV2,
    uouAutoRedirected,
    uouAutoRedirectTriggered,
    uouBounced,
    uouButtonClickSrc146Evid92,
    uouCloseAction,
    uouCouponCopied,
    uouCreatePaymentIntent,
    uouDestinationRedirectedOnBack,
    uouDestinationRedirectedSrc146Evid33,
    uouEngagementClicked,
    uouFormSubmitted,
    uouHypeBannerClicked,
    uouInputEdited,
    uouLockActionUnlocked,
    uouLockActionViewedSrc146Evid88,
    uouPageRefresh,
    uouPageSkipClicked,
    uouPageUnload,
    uouPageViewed,
    uouPageVisibilityChange,
    uouPaymentConfirmation,
    uouProceeded,
    uouSearchBoxClicked,
    uouSocialIconClicked,
    uouSpeedDialLinkRedirected,
    uouSubmitPaymentIntent,
    uouToggleAction,
    uouViewedInnerItemGoalAchieved
} from '@wix/bi-logger-hype-data/v2'

export const doppeViewerBiEvents = {
    uouPageViewed,
    uouPageSkipClicked,
    uouEngagementClicked,
    uouHypeBannerClicked,
    uouPageVisibilityChange,
    uouPageRefresh,
    uouPageUnload,
    uouBounced,
    uouProceeded,
    uouActivity,
    uouActionViewed,
    uouAutoRedirected,
    uouAutoRedirectTriggered,
    uouAutoRedirectCanceled: uouAutoRedirectCanceledV2,
    uouActionClicked,
    uouAnyActionClicked,
    uouCtaButtonClicked: uouActionCtaButtonClickedSrc146Evid95,
    uouCtaButtonViewed: uouActionCtaButtonViewedSrc146Evid96,
    uouToggleAction,
    uouCloseAction,
    uouDestinationRedirected: uouDestinationRedirectedSrc146Evid33,
    uouDestinationRedirectedOnBack,
    uouSpeedDialLinkRedirected,
    uouCouponCopied,
    uouSearchBoxClicked,
    uouSocialIconClicked,
    uouFormSubmitted,
    uouActionInnerItemGoalAchieved,
    uouInputEdited,
    uouCreatePaymentIntent,
    uouSubmitPaymentIntent,
    uouPaymentConfirmation,
    uouViewedInnerItemGoalAchieved,
    uouButtonClick: uouButtonClickSrc146Evid92,
    uouLockActionViewed: uouLockActionViewedSrc146Evid88,
    uouLockActionUnlocked: uouLockActionUnlocked,
    uouActionUnlocked: uouActionUnlocked,
    uouActionStartUnlocking: uouActionStartUnlockingSrc146Evid91,
    uouActionImpression: uouActionImpressionSrc146Evid93,
    uouActionInnerItemPreviewed: uouActionInnerItemPreviewedSrc146Evid94,

}

export function doppeViewerWixWebBiLoggerCreate () {
    return webBiLogger.factory({useBatch: true}).logger()
}

export type DoppeViewerBiEvents = keyof typeof doppeViewerBiEvents